import { render, staticRenderFns } from "./ProfileDetailItem.vue?vue&type=template&id=da510e02&"
import script from "./ProfileDetailItem.vue?vue&type=script&lang=js&"
export * from "./ProfileDetailItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports